// This duplicates code from useSpecificCube to prevent what I think is a lot
// of overhead of calling useSpecificCube , which provides many things and
// reactive values on each cube in a list.
// To minimize a possible performance bottleneck we provide the values needed
// in cube lists which might not be reactive as the counterparts in useSpecificCube
import { useMapStore } from '@/stores/useMapStore'

export function useManyCubes() {

  const hasProduction = (cube) => {
    return cube.hasProduction
  }

  const cubeIsClickable = (cube) => {
    if (hasProduction(cube) || cube.canReceiveDonations) {
      return true
    }

    const imgDetails = cube.params.infoWindowImageDetails
    const hasDescription = !!cube.params.infoWindowText
    const hasImage = !!imgDetails?.original?.url
    return hasDescription || hasImage
  }

  // TODO Move this into preprocessing or the backend?
  const getCoordinates = (cube) => {
    try {
      const lat = parseFloat(cube.params.latitude)
      const lon = parseFloat(cube.params.longitude)

      return {
        lat,
        lon,
      }
    }
    catch (e) {
      throw new Error('Cube ' + cube.cubeName + ' has invalid coordinates: ' + e)
    }
  }

  const gridFeeDiscountApplies = (cube) => {
    // All cubes get 'gridFeeDiscountApplies' set in preprocessCube().
    // If this is false the discount won't be applied, no matter what.
    if (!cube.gridFeeDiscountApplies) {
      return false
    }

    // If the cube is a producer, we additionally check if the grid fee
    // discount is set in the producer prices.
    if (hasProduction(cube)) {
      const prices = useMapStore().getProducerPrices(cube.cubeName)
      return prices && prices.gridFeeDiscountApplies
    }

    return true
  }

  const gridFeeDiscountPriceBrutto = (cube) => {
    const prices = useMapStore().getProducerPrices(cube.cubeName)
    return prices && prices.gridFeeDiscountApplies ? prices.gridFeeDiscountPriceBrutto : 0
  }

  const gridFeeDiscountPriceNetto = (cube) => {
    const prices = useMapStore().getProducerPrices(cube.cubeName)
    return prices && prices.gridFeeDiscountApplies ? prices.gridFeeDiscountPriceNetto : 0
  }

  return {
    hasProduction,
    getCoordinates,
    cubeIsClickable,
    gridFeeDiscountApplies,
    gridFeeDiscountPriceBrutto,
    gridFeeDiscountPriceNetto,
  }
}